import { ApolloClient, InMemoryCache, gql } from '@apollo/client';

export const bitstrayQuery = (id: string) => gql`
 {
	bitstray(id:"${id}") {
	  id
	  seed {
	  background
	  arms
	  shirt
	  motive
	  head
	  eyes
	  mouth
	}
	  owner {
		id
	  }
	}
  }
 `;

export const bitstraysIndex = () => gql`
  {
    bitstrays {
      id
      owner {
        id
      }
    }
  }
`;

export const clientFactory = (uri: string) =>
  new ApolloClient({
    uri,
    cache: new InMemoryCache(),
  });
